
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import CollapseItem from '@/components/collapse.vue';
	import Message from '@/components/message.vue';
	import {
		imgHost,
		maxspecifications
	} from '@/utils/config';
  import {
    productproductProviderSupplyPrice,
    productproductProviderSupplyPriceSave,
  } from "@/api/order"
  @Component({  
    name: '',
    components: {
      PageFooter,
      CollapseItem,
			'slz-message': Message,
    }
  })

  export default class ProductList extends Vue {
    private shop = {
      Name:decodeURIComponent((this as any).$route.query.Name),
      Img:decodeURIComponent((this as any).$route.query.Img),
    }
		private defaultThumb = 'https://cdn2024.routuan.com/routuanapp/default-thumb.png';
    private loading = false
    private ProductInfo:any = {}
    private skuName = []
    private specificationsNum = maxspecifications
    private shoplist:any = []
    private ProviderSupplyPrice = ''
    private totalSku:any = []
    private orderSaveTips = false
		private errorTipsShow = false
		private errorType = 40000001


    private mounted () {
      this.getDate()
    }
    
    private changAllPricd2(e,type,v,i){
      let two = /^\d+(\.\d{1,2})?$/
      let ProviderSupplyPrice = this.totalSku[i].ProviderSupplyPrice
      if(Number(ProviderSupplyPrice)<0.01||Number(ProviderSupplyPrice)>999999.99||!two.test(ProviderSupplyPrice)){
        this.$message.error('请输入0.01~999999.99的数值,最多2位小数')
        this.totalSku[i].ProviderSupplyPrice = ''
        return
      }
      this.ProductInfo.ProductMixList = this.ProductInfo.ProductMixList.map((v,index)=>{
        if(index==i){
          v.ProductSpecList = v.ProductSpecList.map(x=>{
            x.ProviderSupplyPrice = this.totalSku[i].ProviderSupplyPrice
            return x
          })
        }
        return v
      })
    }
    private changAllPricd(e,type,v,i){
      let two = /^\d+(\.\d{1,2})?$/
      let ProviderSupplyPrice = this.totalSku[i].ProviderSupplyPrice
      if(Number(ProviderSupplyPrice)<0.01||Number(ProviderSupplyPrice)>999999.99||!two.test(ProviderSupplyPrice)){
        this.$message.error('请输入0.01~999999.99的数值,最多2位小数')
        this.totalSku[i].ProviderSupplyPrice = ''
        return
      }
      this.ProductInfo.ProductSpecList = this.ProductInfo.ProductSpecList.map((v,index)=>{
        if(i==index){
          v = v.map(x=>{
            x.ProviderSupplyPrice = this.totalSku[i].ProviderSupplyPrice
            return x
          })
        }
        return v
      })
    }
    private setProviderSupplyPrice(){
      if(!this.ProviderSupplyPrice){
        return
      }
      let two = /^\d+(\.\d{1,2})?$/
      let ProviderSupplyPrice = Number(this.ProviderSupplyPrice)
      if(ProviderSupplyPrice<0.01||ProviderSupplyPrice>999999.99||!two.test(this.ProviderSupplyPrice)){
        this.$message.error('请输入0.01~999999.99的数值,最多2位小数')
        this.ProviderSupplyPrice = ''
        return
      }
      if(this.ProductInfo.ProductType==0){
        if(!this.ProductInfo.IsIncludedSubmitOrderInfo){
          this.ProductInfo.ProductSpecList = this.ProductInfo.ProductSpecList.map(v=>{
            v.ProviderSupplyPrice = this.ProviderSupplyPrice
            return v
          })
        }else{
          this.ProductInfo.ProductSpecList = this.ProductInfo.ProductSpecList.map(v=>{
            v = v.map(x=>{
              x.ProviderSupplyPrice = this.ProviderSupplyPrice
              return x
            })
            return v
          })
        }
      }else{
        this.ProductInfo.ProductSpecList = this.ProductInfo.ProductSpecList.map((v,index)=>{
          v.ProviderSupplyPrice = this.ProviderSupplyPrice
          return v
        })
      }
    }
    private getskuName(){
      this.skuName = []
      for(let i = 0;i<this.specificationsNum;i++){
        let key = 'SpecTitle'+(i==0?'':i+1)
        if(this.ProductInfo[key]){
          this.skuName.push({
            sku_name: this.ProductInfo[key],
            sku_info: [],
            key:Math.random(),
            Sort:i+1,
          })
        }
      }
      this.ProductInfo.ProductSpecList.map(item=>{
        for(let i = 0;i<this.specificationsNum;i++){
          let key = 'SpecValue'+(i==0?'':i+1)
          if(item[key] && this.skuName[i]){
            var have = null;
            this.skuName[i].sku_info.map((obj: any, index: number) => {
              if (obj.sku_value === item[key]) {
                have = obj;
              }
            })
            if (!have) {
              let data = {
                sku_value: item[key],
              }
              this.skuName[i].sku_info.push(data)
            }
          }
        }
      })
      // console.log(this.ProductInfo,this.skuName)
    }
    private getShoplist(){
      if(this.ProductInfo.ProductType==0){
        // console.log(1)
        if(this.ProductInfo.IsIncludedSubmitOrderInfo){
          let list = this.getshardlist(this.ProductInfo.ProductSpecList)
          this.totalSku = list.map(v=>{
            return {
              ProviderSupplyPrice:''
            }
          })
          this.ProductInfo.ProductSpecList = list
        }
        this.ProductInfo.ProductSpecList = this.ProductInfo.ProductSpecList.map(v=>{
          v.ProviderSupplyPrice = v.ProviderSupplyPrice || ''
          return v
        })
      }else if(this.ProductInfo.ProductType==1){
        // console.log(2)
        this.ProductInfo.ProductMixList.sort((a,b)=>{
          return b.ProductId - a.ProductId
        })
        let list = this.getassemblylist(this.ProductInfo.ProductMixList)
        this.totalSku = list.map(v=>{
          return {
            ProviderSupplyPrice:''
          }
        })
        this.ProductInfo.ProductMixList = list.map(v=>{
          v.ProductSpecList = v.ProductSpecList.map(x=>{
            x.ProviderSupplyPrice = x.ProviderSupplyPrice || ''
            return x
          })
          return v
        })
        this.ProviderSupplyPrice = this.ProductInfo.ProductSpecList[0].ProviderSupplyPrice||''
      }
      // console.log(this.ProductInfo)
    }
    private getshardlist(list:any){
      let sku = JSON.parse(JSON.stringify(this.skuName))
			let newlist:any = []
			sku[0].sku_info.map((v,i)=>{
				let data:any = []
				list.map(x=>{
					if(x.SpecValue==v.sku_value){
						data.push(x)
					}
				})
				newlist.push(data)
			})
			return newlist
    }
    private getassemblylist(list:any){
      return list.map((v,i)=>{
        v.skuName = []
        for(let i = 0;i<this.specificationsNum;i++){
          let key = 'SpecTitle'+(i==0?'':i+1)
          if(v[key]){
            v.skuName.push({
              sku_name: v[key],
              sku_info: [],
              key:Math.random(),
              Sort:i+1,
            })
          }
        }
        v.ProductSpecList.map(item=>{
          for(let i = 0;i<this.specificationsNum;i++){
            let key = 'SpecValue'+(i==0?'':i+1)
            if(item[key] && v.skuName[i]){
              var have = null;
              v.skuName[i].sku_info.map((obj: any, index: number) => {
                if (obj.sku_value === item[key]) {
                  have = obj;
                }
              })
              if (!have) {
                let data = {
                  sku_value: item[key],
                }
                v.skuName[i].sku_info.push(data)
              }
            }
          }
        })
        return v
      })
    }
    private async getDate(){
      try{
        this.loading = true
        let res:any = await productproductProviderSupplyPrice({
          // Id:this.form.Id||'',
          ProductId:this.$route.query.Id
        })
        if(res.IsSuccess){
          this.ProductInfo = res.Result
          this.getskuName()
          this.getShoplist()
        }
      }finally{
        this.loading = false
      }
    }
    private getProductInfo(){
      let ProductInfo = JSON.parse(JSON.stringify(this.ProductInfo))
      
      ProductInfo.ProductId = this.$route.query.Id
      if(ProductInfo.ProductType==0&&ProductInfo.IsIncludedSubmitOrderInfo){
        let list = []
        ProductInfo.ProductSpecList.map(v=>{
          v.map(x=>{
            list.push(x)
          })
        })
        ProductInfo.ProductSpecList = list
      }
      return ProductInfo
    }
    private test(){
      let two = /^\d+(\.\d{1,2})?$/
      let ProductInfo = JSON.parse(JSON.stringify(this.ProductInfo))
      //单品
      if(ProductInfo.ProductType==0){
        //不计入交单
        if(!this.ProductInfo.IsIncludedSubmitOrderInfo){
          for(let item of ProductInfo.ProductSpecList){
            if(Number(item.ProviderSupplyPrice)<0.01||Number(item.ProviderSupplyPrice)>999999.99||!two.test(item.ProviderSupplyPrice)){
              this.$message.error('请输入正确的供货价')
              return false
            }
          }
        }else{
          for(let item of ProductInfo.ProductSpecList){
            for(let item2 of item){
              if(Number(item2.ProviderSupplyPrice)<0.01||Number(item2.ProviderSupplyPrice)>999999.99||!two.test(item2.ProviderSupplyPrice)){
                this.$message.error('请输入正确的供货价')
                return false
              }
            }
          }
        }
      }else{
        //以组合商品下单
        if(ProductInfo.SettlementType==0){
          if(!this.ProviderSupplyPrice){
            this.$message.error('请输入供货价')
            return false
          }
          for(let item of ProductInfo.ProductSpecList){
            if(Number(item.ProviderSupplyPrice)<0.01||Number(item.ProviderSupplyPrice)>999999.99||!two.test(item.ProviderSupplyPrice)){
              this.$message.error('请输入正确的供货价')
              return false
            }
          }
        }else{
          for(let item of ProductInfo.ProductMixList){
            for(let item2 of item.ProductSpecList){
              if(Number(item2.ProviderSupplyPrice)<0.01||Number(item2.ProviderSupplyPrice)>999999.99||!two.test(item2.ProviderSupplyPrice)){
                this.$message.error('请输入正确的供货价')
                return false
              }
            }
          }
        }
      }
      return true
    }
    private save(){
      if(!this.test()) return
      this.orderSaveTips = true
    }
    private async confirmsave(){
      try{
        this.loading = true
        
        let res:any = await productproductProviderSupplyPriceSave({
          ProductInfo:this.getProductInfo(),
          noError:true
        })
        if(res.IsSuccess){
          this.$message.success('保存成功')
          this.$router.go(-1)
        }else{
					if(res.ErrorCode==40000001||res.ErrorCode==40000002){
						this.errorTipsShow = true
						this.errorType = res.ErrorCode
					}else{
						this.$message.error(res.Message)
					}
				}
      }finally{
        this.loading = false
      }
    }
  }
